import localeEs from '@angular/common/locales/es';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { DatePipe, CommonModule, registerLocaleData } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { InterceptorService } from './components/common/interceptor/interceptor.service';
import { NgbPaginationModule, NgbAlertModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { LoaderComponent } from './components/common/loader/loader.component';
import { HallListComponent } from './pages/hall-list/hall-list.component';
import { ExhibitorsComponent } from './pages/exhibitors/exhibitors.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { ModalLoginComponent } from './components/modal-login/modal-login.component';
import { MenuTabsComponent } from './components/menu-tabs/menu-tabs.component';
import { ProductsComponent } from './pages/products/products.component';
import { FiltersComponent } from './components/filters/filters.component';
import { FilterItemsComponent } from './components/filter-items/filter-items.component';
import { FiltersSelectedComponent } from './components/filters-selected/filters-selected.component';
import { NoveltiesComponent } from './pages/novelties/novelties.component';
import { BrandsComponent } from './pages/brands/brands.component';
import { MapsComponent } from './pages/maps/maps.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { MyFavoritesComponent } from './pages/my-favorites/my-favorites.component';
import { CardGridComponent } from './components/card-grid/card-grid.component';
import { CardComponent } from './components/card/card.component';
import { CardDetailComponent } from './pages/card-detail/card-detail.component';
import { ProductCardComponent } from './components/product-card/product-card.component';
import { FilterByLetterPipe } from './components/pipes/filter-by-letter.pipe';
import { CardListComponent } from './components/card-list/card-list.component';
import { CardModernComponent } from './components/card-modern/card-modern.component';
import { FeaturedIconComponent } from "./components/featured-icon/featured-icon.component";
import { BannerComponent } from './components/banner/banner.component';
import { StandDisplayComponent } from './components/stand-display/stand-display.component';
import { CardNoteComponent } from './components/card-note/card-note.component';
import { NoResultsComponent } from './components/no-results/no-results.component';
import { SocialNetworksLinksComponent } from './components/social-networks-links/social-networks-links.component';
import { LoaderThrobberComponent } from './components/loader-throbber/loader-throbber.component';
import { SocialNetworksShareComponent } from './components/social-networks-share/social-networks-share.component';
import { DetailActionsComponent } from './components/detail-actions/detail-actions.component';
import { DetailDescriptionComponent } from './components/detail-description/detail-description.component';
import { DetailFilesComponent } from './components/detail-files/detail-files.component';
import { DetailVideoComponent } from './components/detail-video/detail-video.component';
import { DetailCategoriesComponent } from './components/detail-categories/detail-categories.component';
import { DetailOdsComponent } from './components/detail-ods/detail-ods.component';
import { DetailProductComponent } from './components/detail-product/detail-product.component';
import { CardDetailProductComponent } from './pages/card-detail-product/card-detail-product.component';
import { FilterCategoryComponent } from './components/filter-category/filter-category.component';
import { OrderByPipe } from './components/order-by.pipe';
import { ShareButtonsComponent } from './components/share-buttons/share-buttons.component';
import { RECAPTCHA_SETTINGS, RECAPTCHA_V3_SITE_KEY, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings, RecaptchaV3Module } from 'ng-recaptcha';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { EmailModalComponent } from './components/email-modal/email-modal.component';
import { CONSTANTS } from 'environments/common';
import { ENV } from 'environments/environment';
import { NgxEditorModule } from 'ngx-editor';
import { HomeComponent } from './components/home/home.component';
import { CustomTranslationPipe } from './components/custom-translation/custom-translation.pipe';
import { ModalRecoveryPasswordComponent } from './components/modal-recovery-password/modal-recovery-password.component';
import { ModalRedirectSdaComponent } from './components/modal-redirect-sda/modal-redirect-sda.component';
import { ExhibitorBackofficeUtilInfoComponent } from './pages/exhibitor-backoffice-util-info/exhibitor-backoffice-util-info.component';
import { ContactComponent } from './pages/contact/contact.component';
import { GeneralInformationComponent } from './pages/general-information/general-information.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogComponent } from './components/dialog/dialog.component';
import { ExhibitorBackofficeExhibitorDetailEditComponent } from './pages/exhibitor-backoffice-exhibitor-detail-edit/exhibitor-backoffice-exhibitor-detail-edit.component';
import { EditionPanelComponent } from './components/edition-panel/edition-panel.component';
import { ModalSimpleComponent } from "./components/modal-simple/modal-simple.component";
import { EditExhibitorExhibitorComponent } from './components/edit-exhibitor-exhibitor/edit-exhibitor-exhibitor.component';
import { MenuExhibitorComponent } from './components/menu-exhibitor/menu-exhibitor.component';
import { ExhibitorBackofficeExhibitorsComponent } from './pages/exhibitor-backoffice-exhibitors/exhibitor-backoffice-exhibitors.component';
import { ExhibitorBackofficeExhibitorDetailComponent } from './pages/exhibitor-backoffice-exhibitor-detail/exhibitor-backoffice-exhibitor-detail.component';
import { ExhibitorBackofficeExhibitorProductsComponent } from './pages/exhibitor-backoffice-exhibitor-products/exhibitor-backoffice-exhibitor-products.component';
import { MenuExhibitorSubMenuComponent } from './components/menu-exhibitor-sub-menu/menu-exhibitor-sub-menu.component';
import { ExhibitorBackofficeExhibitorDetailAdminComponent } from './pages/exhibitor-backoffice-exhibitor-detail-admin/exhibitor-backoffice-exhibitor-detail-admin.component';
import { ExhibitorBackofficeExhibitorDetailAdminEditComponent } from './pages/exhibitor-backoffice-exhibitor-detail-admin-edit/exhibitor-backoffice-exhibitor-detail-admin-edit.component';
import { ModalExhibitorModifiedComponent } from './components/modal-exhibitor-modified/modal-exhibitor-modified.component';
import { ModalExhibitorPasswordRecoveryComponent } from './components/modal-exhibitor-password-recovery/modal-exhibitor-password-recovery.component';
import { EditExhibitorMultimediaComponent } from './components/edit-exhibitor-multimedia/edit-exhibitor-multimedia.component';
import { EditProductMultimediaComponent } from './components/edit-product-multimedia/edit-product-multimedia.component';
import { EditExhibitorCategoriesComponent } from './components/edit-exhibitor-categories/edit-exhibitor-categories.component';
import { ExhibitorBackofficeProductDetailComponent } from './pages/exhibitor-backoffice-product-detail/exhibitor-backoffice-product-detail.component';
import { MenuProductSubMenuComponent } from './components/menu-product-sub-menu/menu-product-sub-menu.component';
import { ExhibitorBackofficeProductDetailEditComponent } from './pages/exhibitor-backoffice-product-detail-edit/exhibitor-backoffice-product-detail-edit.component';
import { TranslatedFieldsComponent } from './components/translated-fields/translated-fields.component';
import { ModalYesNoComponent } from './components/modal-yes-no/modal-yes-no.component';
import { ExhibitorBackofficeExhibitorCreateComponent } from './pages/exhibitor-backoffice-exhibitor-create/exhibitor-backoffice-exhibitor-create.component';
import { ExhibitorBackofficeExhibitorsImportComponent } from './pages/exhibitor-backoffice-exhibitors-import/exhibitor-backoffice-exhibitors-import.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ModalImportExhibitorComponent } from './components/modal-import-exhibitor/modal-import-exhibitor.component';
import { AlertComponent } from './components/alert/alert.component';
import { LegalAdviceComponent } from './pages/legal-advice/legal-advice.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { NoWhitespaceValidatorDirective } from './directives/no-whitespace-validator-directive/no-whitespace-validator-directive.component';
import { AutoLoginComponent } from './pages/auto-login/auto-login.component';
import { EditProductsCategoriesComponent } from './components/edit-products-categories/edit-products-categories.component';




// Factory function to create TranslateHttpLoader
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}


// the second parameter 'fr' is optional
registerLocaleData(localeEs, 'es');



@NgModule({
  declarations: [
    AppComponent,
    HallListComponent,
    LoaderComponent,
    ExhibitorsComponent,
    HeaderComponent,
    FooterComponent,
    ModalLoginComponent,
    MenuTabsComponent,
    ProductsComponent,
    NoveltiesComponent,
    FiltersComponent,
    FilterItemsComponent,
    FiltersSelectedComponent,
    BrandsComponent,
    MapsComponent,
    ProfileComponent,
    ChangePasswordComponent,
    MyFavoritesComponent,
    CardGridComponent,
    CardComponent,
    CardDetailComponent,
    ProductCardComponent,
    FilterByLetterPipe,
    CardGridComponent,
    CardListComponent,
    CardModernComponent,
    FeaturedIconComponent,
    BannerComponent,
    StandDisplayComponent,
    CardNoteComponent,
    NoResultsComponent,
    SocialNetworksLinksComponent,
    LoaderThrobberComponent,
    DetailActionsComponent,
    DetailDescriptionComponent,
    DetailFilesComponent,
    DetailVideoComponent,
    DetailCategoriesComponent,
    DetailOdsComponent,
    DetailProductComponent,
    CardDetailProductComponent,
    FilterCategoryComponent,
    OrderByPipe,
    SocialNetworksShareComponent,
    ShareButtonsComponent,
    EmailModalComponent,
    HomeComponent,
    CustomTranslationPipe,
    ModalRecoveryPasswordComponent,
    ModalRedirectSdaComponent,
    ExhibitorBackofficeUtilInfoComponent,
    ContactComponent,
    GeneralInformationComponent,
    DialogComponent,
    ExhibitorBackofficeExhibitorDetailEditComponent,
    EditionPanelComponent,
    ModalSimpleComponent,
    EditExhibitorExhibitorComponent,
    MenuExhibitorComponent,
    ExhibitorBackofficeExhibitorsComponent,
    ExhibitorBackofficeExhibitorDetailComponent,
    ExhibitorBackofficeExhibitorDetailAdminComponent,
    ExhibitorBackofficeExhibitorDetailAdminEditComponent,
    ExhibitorBackofficeExhibitorProductsComponent,
    ExhibitorBackofficeProductDetailComponent,
    MenuExhibitorSubMenuComponent,
    ModalExhibitorModifiedComponent,
    ModalExhibitorPasswordRecoveryComponent,
    EditExhibitorMultimediaComponent,
    EditExhibitorCategoriesComponent,
    EditProductsCategoriesComponent,
    MenuProductSubMenuComponent,
    EditProductMultimediaComponent,
    ExhibitorBackofficeProductDetailEditComponent,
    TranslatedFieldsComponent,
    ModalYesNoComponent,
    ExhibitorBackofficeExhibitorCreateComponent,
    ExhibitorBackofficeExhibitorsImportComponent,
    ModalImportExhibitorComponent,
    AutoLoginComponent,
    AlertComponent,
    LegalAdviceComponent,
    PrivacyPolicyComponent,
    NoWhitespaceValidatorDirective,
    AutoLoginComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    NgbPaginationModule,
    NgbAlertModule,
    NgbTooltipModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    RecaptchaV3Module,
    NgxEditorModule.forRoot({
      locals: {
        // menu
        bold: 'Bold',
        italic: 'Italic',
        code: 'Code',
        blockquote: 'Blockquote',
        underline: 'Underline',
        strike: 'Strike',
        bullet_list: 'Bullet List',
        ordered_list: 'Ordered List',
        heading: 'Heading',
        h1: 'Header 1',
        h2: 'Header 2',
        h3: 'Header 3',
        h4: 'Header 4',
        h5: 'Header 5',
        h6: 'Header 6',
        align_left: 'Left Align',
        align_center: 'Center Align',
        align_right: 'Right Align',
        align_justify: 'Justify',
        text_color: 'Text Color',
        background_color: 'Background Color',
        height: '20rem',
        minHeight: '15rem',
        // popups, forms, others...
        url: 'URL',
        text: 'Text',
        openInNewTab: 'Open in new tab',
        insert: 'Insert',
        altText: 'Alt Text',
        title: 'Title',
        remove: 'Remove',
      },
    }),
    MatDialogModule,
    FontAwesomeModule
  ],
  providers: [
    DatePipe,
    FilterByLetterPipe,
    {
      provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true
    },
    {
      provide: LOCALE_ID,
      useValue: 'es'
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: ENV.CAPTCHA.SITEKEY
      } as RecaptchaSettings
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {
}
